import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as yup from 'yup';
import axios from 'axios';

import { Form, Field, withFormik } from 'formik';

import Notifications, { useNotification } from '../modals/Notifications';

const TutoriumInput = ({ field, form, type, placeholder, isMobile }) => {
  const hasError = form.errors[field.name] && form.touched[field.name];

  const fieldClassName = classnames('form-control', { 'is-invalid': hasError, 'form-control-sm': isMobile });

  return (
    <div className="form-field">
      <Field type={type || 'text'} {...field} className={fieldClassName} placeholder={placeholder} />
    </div>
  );
};

TutoriumInput.propTypes = {
  field: PropTypes.object.isRequired, // TODO
  form: PropTypes.object.isRequired, // TODO
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  isMobile: PropTypes.bool,
};

const initialValues = {
  name: '',
  phone: '',
  email: '',
};

const mapPropsToValues = () => initialValues;

const validationSchema = yup.object().shape({
  name: yup.string().required(),
  phone: yup.string().required(),
  email: yup
    .string()
    .email()
    .required(),
});

const handleSubmit = (props, bag) => {
  bag.setSubmitting(true);

  axios
    .post('/api/v1/messages/participate', { ...props, courseId: bag.props.courseId })
    .then(() => {
      bag.setSubmitting(false);
      bag.props.showSuccessNotification();
      bag.resetForm(initialValues);
    })
    .catch(() => {
      bag.setSubmitting(false);
      bag.props.showErrorNotification();
    });
};

const ParticipateForm = props => {
  return (
    <>
      <Form noValidate>
        <Field name="name" component={TutoriumInput} placeholder="Name" isMobile={props.isMobile} />
        <Field name="phone" component={TutoriumInput} placeholder="Phone" isMobile={props.isMobile} />
        <Field name="email" type="email" component={TutoriumInput} placeholder="Email" isMobile={props.isMobile} />
        <button className={props.btnClassName} disabled={props.isSubmitting} type="submit">
          {!props.isSubmitting && <span>Participate</span>}
          {props.isSubmitting && <span>Sending...</span>}
        </button>
      </Form>
    </>
  );
};

ParticipateForm.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  btnClassName: PropTypes.string.isRequired,
};

const ConnectFormContainer = withFormik({ mapPropsToValues, validationSchema, handleSubmit })(ParticipateForm);

const ConnectFormWithNotifications = props => {
  const successNotificationState = useNotification();
  const errorNotificationState = useNotification();

  return (
    <>
      <ConnectFormContainer
        {...props}
        showSuccessNotification={successNotificationState.open}
        showErrorNotification={errorNotificationState.open}
      />
      <Notifications.TrialRequested state={successNotificationState} />
      <Notifications.Error state={errorNotificationState} />
    </>
  );
};

export default ConnectFormWithNotifications;
